import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../../CustomComponents/FieldInput";
import { expertRegistration } from "../../../../../redux/expert/action";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { companyRegistration } from "../../../../../redux/company/action";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import NumberInputBox from "../../../../CustomComponents/AllCustomeInput/NumberInputBox";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import { bankvalidationSchema } from "../../../../Common/commonvalidation";
import AsteriskLabel from "../../../../Common/AsteriskLabel";

const formdatatomap = [
  { title: (<>Bank Name <AsteriskLabel /></>), name: "bank_name", placeholder: "Enter bank name" },
  {
    title: (<>Account No.</>),
    name: "account_number",
    placeholder: "Enter bank account no",
  },
  {
    title: (<>Confirm Account No.</>),
    name: "confirm_account_number",
    placeholder: "Confirm your bank account no",
  },
  { title: (<>IFSC Code <AsteriskLabel /></>), name: "ifsc_code", placeholder: "Enter IFSC Code" },
  { title: (<>Swift code <AsteriskLabel /></>), name: "swift_code", placeholder: "Enter Swift code" },
  {
    title: (<>Account holder <AsteriskLabel /></>),
    name: "account_holder_name",
    placeholder: "Enter account holder name",
  },
];

const EyeIcon = ({ visible }) =>
  visible ? (
    // Eye open
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ) : (
    // Eye crossed
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M17.94 17.94A10.94 10.94 0 0 1 12 19C5 19 1 12 1 12a18.1 18.1 0 0 1 5.06-5.94M9.9 4.24A9.77 9.77 0 0 1 12 4c7 0 11 8 11 8a18.1 18.1 0 0 1-2.16 3.19M1 1l22 22" />
    </svg>
  );

const IBankDetails = ({ formData, setFormData, previousPage, nextPage }) => {
  const [showAccountNumber, setShowAccountNumber] = useState(false);
  const [showConfirmAccountNumber, setShowConfirmAccountNumber] = useState(false);
  const [loading, setLoading] = useState(false);
  const formikRef = useRef(null);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const initialValues = {
    account_number: formData?.bank_details?.account_number,
    confirm_account_number: formData?.bank_details?.account_number,
    account_holder_name: formData?.bank_details?.account_holder_name,
    bank_name: formData?.bank_details?.bank_name,
    ifsc_code: formData?.bank_details?.ifsc_code,
    swift_code: formData?.bank_details?.swift_code,
  };

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const handleSubmit = async (values) => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    // nextPage()
    setFormData((prevData) => ({
      ...prevData,
      bank_details: values,
    }));

    nextPage();
    setLoading(false);

    // hitapiandsubmitform()
  };
  const hitapiandsubmitform = () => {
    if (formData.iam == 2) {
      dispatch(companyRegistration(formData, navigate))
        .then((response) => {
          if (response?.data?.status) {
            localStorage.setItem("role_type", response?.data?.response.role_type);
            navigate(`/${lan}/account/upgrademembership`);
          }
        })
        .catch((error) => {
          console.error("Something Went Wrong:", error);
        });
    } else {
      dispatch(expertRegistration(formData, navigate))
        .then((response) => {
          if (response?.data?.status) {
            navigate(`/${lan}/account/upgrademembership`);
          }
        })
        .catch((error) => {
          console.error("Something Went Wrong:", error);
        });
    }
  };

  const handleNextClick = () => {
    if (formikRef.current) {
      formikRef.current.submitForm();
    }
  };

  const skipNextClick = () => {
    setFormData((prevData) => ({
      ...prevData,
    }));
    nextPage();
    setLoading(false);
  };


  return (
    <div>
      <div className="row about-row">
        <div className="col-md-5 about-left">
          <h6>
            08/09 <span>Bank details</span>
          </h6>
          <h2>Let us know where your want to receive your earnings</h2>
          <p>Fill up the form to start working on Urxprt</p>
        </div>
        <div className="col-lg-6   about-right">
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            innerRef={formikRef}
            validationSchema={bankvalidationSchema}
            enableReinitialize
          >
            {(formik) => (
              <Form>
                <div className="add-skip">
                  <h6>Bank Details </h6>
                  <a onClick={() => skipNextClick()} type="text">
                    Skip for now
                  </a>
                </div>
                <div>
                  {formdatatomap.map((prop, key) => {
                    if (prop.name == "bank_name" || prop.name == "account_holder_name") {
                      return (
                        <div key={key} className="form-group">
                          <label>{prop.title}</label>
                          <Field name={prop.name}>
                            {({ field, form: innerForm }) => (
                              <input
                                {...field}
                                type="text"
                                placeholder={prop.placeholder}
                                className="form-control"
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "Backspace" ||
                                    e.key === "Delete" ||
                                    e.key === "ArrowLeft" ||
                                    e.key === "ArrowRight" ||
                                    e.key === "Tab" ||
                                    e.key === " " ||
                                    e.ctrlKey ||
                                    e.metaKey
                                  ) return;
                                  if (!/^[a-zA-Z]$/.test(e.key)) e.preventDefault();
                                }}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (/^[a-zA-Z\s]*$/.test(val)) {
                                    innerForm.setFieldValue(prop.name, val);
                                  }
                                }}
                                value={field.value || ""}
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name={prop.name}
                            component="div"
                            className="error"
                            style={{ color: "red" }}
                          />
                        </div>
                      );
                    }
                    if (prop.name == "ifsc_code") {
                      return (
                        <FieldInput
                          title={prop.title}
                          name={prop.name}
                          placeholder={prop.placeholder}
                          key={key}
                        />
                      );
                    }
                    if (prop.name == "swift_code") {
                      return (
                        <FieldInput
                          title={prop.title}
                          name={prop.name}
                          placeholder={prop.placeholder}
                          key={key}
                        />
                      );
                    }
                    // ── Masked account number fields ──────────────────────
                    const isAccountNo = prop.name === "account_number";
                    const isConfirmNo = prop.name === "confirm_account_number";
                    const isVisible = isAccountNo ? showAccountNumber : showConfirmAccountNumber;
                    const toggleFn = isAccountNo
                      ? () => setShowAccountNumber((v) => !v)
                      : () => setShowConfirmAccountNumber((v) => !v);

                    return (
                      <div key={key} className="form-group">
                        <label>
                          {prop.title}
                        </label>
                        <div style={{ position: "relative" }}>
                          <Field name={prop.name}>
                            {({ field, form: innerForm }) => (
                              <input
                                {...field}
                                type={isVisible ? "text" : "password"}
                                placeholder={prop.placeholder}
                                className="form-control"
                                style={{ paddingRight: "2.5rem" }}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "Backspace" ||
                                    e.key === "Delete" ||
                                    e.key === "ArrowLeft" ||
                                    e.key === "ArrowRight" ||
                                    e.key === "Tab" ||
                                    e.ctrlKey ||
                                    e.metaKey
                                  ) return;
                                  if (!/[0-9]/.test(e.key)) e.preventDefault();
                                }}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (val === "" || /^\d{0,20}$/.test(val)) {
                                    innerForm.setFieldValue(prop.name, val);
                                  }
                                }}
                                value={field.value || ""}
                              />
                            )}
                          </Field>
                          <button
                            type="button"
                            onClick={toggleFn}
                            title={isVisible ? "Hide" : "Show"}
                            style={{
                              position: "absolute",
                              right: "0.6rem",
                              top: "50%",
                              transform: "translateY(-50%)",
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              color: "#6c757d",
                            }}
                          >
                            <EyeIcon visible={isVisible} />
                          </button>
                        </div>
                        <ErrorMessage
                          name={prop.name}
                          component="div"
                          className="error"
                          style={{ color: "red" }}
                        />
                      </div>
                    );
                  })}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <div className="button-container">
        <button
          disabled={loading}
          type="button"
          onClick={previousPage}
          className="prev-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/back-arrow.svg`}
            alt="Back"
          />
          Back
        </button>
        <button
          type="button"
          onClick={() => handleNextClick()}
          className="next-button"
        >
          {loading ? (
            <LoginLoaderButton />
          ) : (
            <>
              Next
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                alt=""
              />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default IBankDetails;
